import React, {  } from "react";
import Grid from '@mui/material/Grid2';
import { Typography, Box, Divider } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorIcon from '@mui/icons-material/Error';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';

const PACheckResultsProcedure = (props) => {
	const { color, proceduresList, title } = props;

  return (
		<Box>
			<Box sx={{
				backgroundColor: `${color}`,
				color: "#fff",
				p: 1,
				borderRadius: 1,
			}}>
				{color === "#ff0000" ? (
					<ErrorIcon sx={{ color: "#fff", mr: 1 }} />
				) : color === "#057251" ? (
					<CheckCircleRoundedIcon sx={{ color: "#fff", mr: 1 }} />
				) : (
					<HelpRoundedIcon sx={{ color: "#fff", mr: 1 }} />
				)}				
				<span style={{position: 'relative', top: '-5px'}}><strong>{title}</strong> | {proceduresList?.length} Procedures</span>
			</Box>

			{/* Procedure List */}
			<Box sx={{ pl: 2, pr: 2 }}>
				{proceduresList?.map((p, i) => (
					<React.Fragment key={i}>
						<Grid container>
							<Grid item size={{ xs: 12 }}>
								<Box sx={{
									display: "flex",
									alignItems: "center",
									color: {color},
									fontWeight: "bold",
									mb: 2,
									mt: 2,
								}}>
									{color === "#ff0000" ? (
										<ErrorIcon sx={{ color: color, mr: 1 }} />
									) : color === "#057251" ? (
										<CheckCircleRoundedIcon sx={{ color: color, mr: 1 }} />
									) : (
										<HelpRoundedIcon sx={{ color: color, mr: 1 }} />
									)}
									{p.procedure_code} - {p.procedure_name}
								</Box>
							</Grid>
							<Grid item size={{ xs: 6 }}>
								{p.medical_policy && p.medical_policy.length > 0 && (<>
									<Typography variant="body2" fontWeight="bold" sx={{ mb: 2 }}>Medical Policies/Criteria That May Apply:</Typography>
									{p.medical_policy.map((policy, idx) => (
										<Typography variant="body2" fontWeight="bold" key={idx} style={{marginBottom: '15px'}}>
											{policy?.weburl ? (
												<a href={policy?.weburl} target="_blank" rel="noopener noreferrer">
													{policy?.shortname} - {policy?.version_shortname}
												</a>
											) : (
												<span>{policy?.shortname} - {policy?.version_shortname}</span>
											)}
										</Typography>
									))}
									{p?.instructions && p?.instructions.length > 0 && p?.instructions.map((instruction, idx) => (
										<>
											{instruction?.clinical_criteria?.toLowerCase() === "y" && (
												<React.Fragment key={idx}>									
													<p style={{margin: '10px 0px'}}>{instruction.text}</p>
												</React.Fragment>
											)}
										</>
									))}
								</>)}
							</Grid>
							<Grid item size={{ xs: 6 }}>
								{p?.instructions && p?.instructions.length > 0 && (
									<>
										<Typography variant="body2" fontWeight="bold" sx={{ mb: 2 }}>Additional Procedure Information:</Typography>
										{p?.instructions.map((instruction, idx) => (
											<>
												{instruction?.clinical_criteria?.toLowerCase() !== "y" && (
													<React.Fragment key={idx}>									
														<p style={{margin: '10px 0px'}}>{instruction.text}</p>
													</React.Fragment>
												)}
											</>
										))}
									</>								
								)}
							</Grid>
						</Grid>
						<Divider sx={{ my: 1 }} />
					</React.Fragment>
				))}
			</Box>
		</Box>
	);
};

export default PACheckResultsProcedure;
